import {Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'carm-public-menu-html-en',
  templateUrl: './public-menu-html-en.component.html',
  styleUrls: ['./public-menu-html-en.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PublicMenuHtmlEnComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
